import React from 'react';
import { Box, Typography, Card, CardContent, CardActionArea, Container } from '@mui/material';
import SEO from '../components/SEO/SEO';
import { useSigilContext } from '../context/sigilContext';
import { Link } from 'react-router-dom';

const Grimoire = () => {
    const { i18n } = useSigilContext();

    // Fallback en caso de que i18n aún no haya cargado correctamente la nueva sección
    const grimoireData = i18n?.grimoire || { title: 'El Grimorio', description: '', articles: [] };

    return (
        <>
            <SEO
                title={`${grimoireData.title} | Magia del Caos`}
                description={grimoireData.description}
                name="Magia del Caos"
                type="blog"
            />
            <Container maxWidth="md" sx={{ py: 4, height: 'calc(100vh - 64px)', overflowY: 'auto' }}>
                <Typography variant="h3" component="h1" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold', textAlign: 'center', mb: 2 }}>
                    {grimoireData.title}
                </Typography>
                
                <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.7)', textAlign: 'center', mb: 5, fontStyle: 'italic' }}>
                    {grimoireData.description}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {grimoireData.articles && grimoireData.articles.map((article) => (
                        <Card 
                            key={article.id} 
                            sx={{ 
                                backgroundColor: 'rgba(44, 44, 44, 0.8)', 
                                borderRadius: '16px',
                                border: '1px solid rgba(255,255,255,0.1)',
                                transition: '0.3s',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
                                    borderColor: 'primary.main'
                                }
                            }}
                        >
                            <CardActionArea component={Link} to={`/grimoire/${article.id}`} sx={{ p: 2 }}>
                                <CardContent>
                                    <Typography variant="caption" sx={{ color: 'secondary.main', fontWeight: 'bold' }}>
                                        {article.date}
                                    </Typography>
                                    <Typography variant="h5" component="h2" sx={{ color: 'white', fontWeight: 'bold', mt: 1, mb: 1.5 }}>
                                        {article.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                        {/* Mostramos solo el principio del primer párrafo como extracto */}
                                        {article.content && article.content[0]}
                                    </Typography>
                                    
                                    <Typography variant="button" sx={{ color: 'primary.main', mt: 2, display: 'inline-block', fontWeight: 'bold' }}>
                                        {grimoireData.readMore || 'Read More'} →
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
                </Box>
            </Container>
        </>
    );
};

export default Grimoire;
